export enum EmploymentType {
    HOURLY = 'HOURLY',
    SALARIED = 'SALARIED',
    SELF_EMPLOYED = 'SELF_EMPLOYED'
}

